export const config = {
  getMyCollege: "https://api.reef.org.in",
  cookieName: "clg_user",
  sessionCookie: "clg_sess",
};
